export const ROLES = {
  admin: 'admin',
  doctor: 'doctor',
  staff: 'staff',
  tester: 'tester',
}
